<template>
    <div>
        <button class="btn btn-primary btn-contact" @click="showModal">Contact us</button>

        <modal name="contact-form" height="auto" width="900" :scrollable="true" @opened="flfix">
            <div class="contact-form">
                <button @click="$modal.hide('contact-form')">
                    <feather-x></feather-x>
                </button>
                <div class="contact-form--form">

                    <h2>Send us a message and we'll get back at you!</h2>

                    <form method="post" class="form-contact-us" @submit.prevent="submitForm">
                        <fieldset>
                            <div class="form-group">
                                <label for="input-name">Your name</label>
                                <input type="text" name="name" id="input-name" class="form-control" v-validate="'required'">
                                <span v-show="errors.has('name')" class="help is-danger">{{ errors.first('name') }}</span>
                            </div>
                            <div class="form-group">
                                <label for="input-email">Your e-mail address</label>
                                <input type="text" name="email" id="input-email" class="form-control" v-validate="'required|email'">
                                <span v-show="errors.has('email')" class="help is-danger">{{ errors.first('email') }}</span>
                            </div>
                            <div class="form-group">
                                <label for="input-phone">Your phone</label>
                                <input type="text" id="input-phone" class="form-control">
                            </div>
                            <div class="form-group">
                                <label for="input-note">What's up?</label>
                                <textarea id="input-note" name="note" class="form-control" v-validate="'required|min:10'"></textarea>
                                <span v-show="errors.has('note')" class="help is-danger">{{ errors.first('note') }}</span>
                            </div>

                            <button class="btn btn-primary" :disabled="sending">Send <feather-chevron-right></feather-chevron-right></button>

                        </fieldset>
                    </form>

                </div>

                <div class="contact-form--info">
                    <p>
                        KREATORIJ, d.o.o.<br>
                        <a href="https://goo.gl/maps/j3zkoKiE5qw" target="_blank">Litostrojska cesta 52</a><br>
                        1000 Ljubljana<br>
                        Slovenia
                    </p>
                    <p>
                        <a href="tel:+38641775783">+386 41 775 783</a><br>
                        <a href="tel:+38631201497">+386 31 201 497</a><br>
                        <a href="mailto:info@kreatorij.si">info@kreatorij.si</a><br>
                    </p>
                </div>

            </div>
        </modal>
    </div>
</template>
<script>
    import FloatLabels from 'float-labels.js';
    import VeeValidate from 'vee-validate';
    import serialize from 'form-serialize';

    const dictionary = {
        en: {
            custom: {
                name: {
                    required: 'Please enter your name'
                },
                email: {
                    required: 'Please enter your e-mail address',
                    email: 'Please enter a valid e-mail address'
                },
                note: {
                    required: 'Don\'t you have anything to say?'
                },
            },
        }
    };
    Vue.use(VeeValidate, {
        dictionary: dictionary
    });

    export default {
        name: 'ContactComponent',
        data () {
            return {
                sending: false
            }
        },
        methods: {
            showModal () {
                this.$modal.show('contact-form');
            },

            submitForm (e) {
                e.preventDefault();

                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.sending = true;
                        axios({
                            url: '/api/contact',
                            method: 'post',
                            responseType: 'json',
                            data: serialize(document.querySelector('.form-contact-us'), {
                                hash: false,
                                empty: true
                            })

                        }).then(response => {
                            document.querySelector('.contact-form--form').innerHTML = '<p>Thanks!</p>';
                        });
                        return;
                    }
                });

                return false;
            },

            flfix () {
                new FloatLabels( 'form', {
                    customEvent      : null,
                    customLabel      : null,
                    customPlaceholder: null,
                    exclude          : '.no-label',
                    inputRegex       : /email|number|password|search|tel|text|url/,
                    prefix           : 'fl-',
                    prioritize       : 'label',
                    requiredClass    : 'required',
                    style            : 2,
                    transform        : 'input, select, textarea',
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/ContactComponent.vue